// extracted by mini-css-extract-plugin
module.exports = {"body":"CommonStyle_body__okIme","main":"CommonStyle_main__rA-_-"};